import * as FaIcons from 'react-icons/fa';

const DEFAULT_ICON = 'FaQuestionCircle';

const ButtonIcon = ({ iconName, size = 20, color }) => {
  const IconComponent = FaIcons[iconName] || FaIcons[DEFAULT_ICON];
  return <IconComponent size={size} color={color} />;
};

export default ButtonIcon;
